import "./ConfirmDialog.css";
import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";

export default function ConfirmDialog({
  open,
  title = "Confirmer la suppression",
  message = "Voulez-vous vraiment annuler cette demande ?",
  confirmLabel = "Oui, supprimer",
  cancelLabel = "Annuler",
  onConfirm,
  onClose,
  actions,
}) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  useEffect(() => {
    if (!open) return;
    const prev = document.documentElement.style.overflow;
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.documentElement.style.overflow = prev;
    };
  }, [open]);

  if (!open || !mounted) return null;

  const node = (
    <div
      className="fixed inset-0 z-[9999]"
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-title"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onKeyDown={(e) => e.key === "Escape" && onClose()}
    >
      {/* Overlay sombre */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
      />

      {/* Contenu de la modale centré */}
      <div
        className="relative z-10 w-full max-w-sm mx-4"
        style={{
          position: "relative",
          zIndex: 10000,
          width: "100%",
          maxWidth: "24rem",
          margin: "0 1rem",
        }}
      >
        <div
          className="bg-white rounded-2xl shadow-2xl border p-6"
          style={{
            backgroundColor: "white",
            borderRadius: "1rem",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
            border: "1px solid #e5e7eb",
            padding: "1.5rem",
          }}
        >
          <h3
            id="confirm-title"
            className="text-lg font-semibold mb-4 text-center"
          >
            {title}
          </h3>

          <div className="text-sm text-gray-700 mb-6 text-center">
            {message}
          </div>

          {actions ? (
            <div style={{ marginTop: "12px" }}>{actions}</div>
          ) : (
            <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
              <button
                autoFocus
                type="button"
                onClick={onClose}
                style={{
                  flex: 1,
                  padding: "12px 16px",
                  border: "1px solid #d1d5db",
                  borderRadius: "8px",
                  backgroundColor: "white",
                  color: "#6b7280",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                  transition: "all 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f9fafb";
                  e.target.style.borderColor = "#9ca3af";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "white";
                  e.target.style.borderColor = "#d1d5db";
                }}
              >
                {cancelLabel}
              </button>
              <button
                type="button"
                onClick={onConfirm}
                style={{
                  flex: 1,
                  padding: "12px 16px",
                  border: "none",
                  borderRadius: "8px",
                  backgroundColor: "#dc2626",
                  color: "white",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                  transition: "all 0.2s",
                }}
                onMouseEnter={(e) => (e.target.style.backgroundColor = "#b91c1c")}
                onMouseLeave={(e) => (e.target.style.backgroundColor = "#dc2626")}
              >
                {confirmLabel}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return createPortal(node, document.body);
}
